import { GlButton } from '@adl/component-button'
import { GlIcon } from '@adl/component-icon'
import { useTranslations, Translations } from '@crystal/translator'
import { Dispatch, FC, SetStateAction } from 'react'

import styles from './account-portal.module.scss'

interface ShowHidePasswordButtonProps {
  showPassword: boolean
  setShowPassword: Dispatch<SetStateAction<boolean>>
}

export const ShowHidePasswordButton: FC<ShowHidePasswordButtonProps> = ({ showPassword, setShowPassword }) => {
  const t = useTranslations<Translations>()

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div
      className={`${styles['show-hide-password-wrapper']} gl-flex-display gl-flex-justify-content-end gl-flex-align-items-center`}>
      <GlIcon name={showPassword ? 'hide-active' : 'hide-inactive'} />
      <GlButton
        id="show-hide-password"
        onClick={togglePasswordVisibility}
        className={styles['show-hide-password-button']}
        variant="tertiary">
        {showPassword ? t('password.hide') : t('password.show')}
      </GlButton>
    </div>
  )
}
